// libraries.
import { DropdownButton } from '@habitech/call-to-action';

// utils.
import { getAgentsByEnv } from './utils';

interface DropdownAgentsProps {
  value: string;
  onSelectAgent: (agentId: string) => void;
}
interface Option {
  value: string;
  label: string;
}

export const DropdownAgents = ({
  onSelectAgent,
  value,
}: DropdownAgentsProps) => {
  const country = localStorage.getItem('country') as 'MX' | 'CO';
  const agentValues = getAgentsByEnv(country);

  const agentOptions: Option[] = agentValues?.map(agentId => ({
    value: agentId,
    label: agentId,
  }));

  return (
    <div className="d-flex w-100">
      <DropdownButton
        dataId="agents-id"
        listOptions={agentOptions}
        placeholder="Agentes"
        value={value}
        setValue={e => {
          onSelectAgent(e as string);
        }}
        variant="white"
        size="fluid"
      />
    </div>
  );
};
